import { DEFAULT_LIMIT, getFolders } from './getFolders';
import { selectFolders } from '../../selectors/folders';
import { TThunkAction } from '../../types/redux';

export const refreshFolders = (): TThunkAction<void> => (dispatch, getState) => {
  const folders = selectFolders(getState());

  dispatch(getFolders({ limit: Math.max(folders.length, DEFAULT_LIMIT) }));
};
